<template>
    <feature-toggle :toggle="allowApplyAllNotifications">
        <v-tooltip
            v-if="isChild"
            :text="disabledReason"
            location="bottom"
            :disabled="!isDisabled || !disabledReason"
        >
            <template v-slot:activator="{ props }">
                <span v-bind="props">
                    <v-btn
                        primary
                        depressed
                        :disabled="isDisabled"
                        @click.stop="$refs.dialog.open()"
                    >
                        {{ $t(`acceptAllNotifications.acceptAllNotifications`) }}
                    </v-btn>
                </span>
            </template>
        </v-tooltip>

        <confirm-dialog
            ref="dialog"
            :question-text="
                isScenario
                    ? $t(`acceptAllNotifications.confirmTextScenario`)
                    : $t(`acceptAllNotifications.confirmTextPromotion`)
            "
            :action-text="$t('actions.confirm')"
            :has-activator="false"
            @confirm="$store.dispatch(`${entity}/acceptAllNotifications`, { entityId })"
        />
    </feature-toggle>
</template>

<script>
import featureFlags from '@enums/feature-flags';

const { allowApplyAllNotifications } = featureFlags;

export default {
    props: {
        entity: {
            required: true,
            type: String,
        },
        entityId: {
            required: true,
            type: String,
        },
        applyingNotifications: {
            type: Boolean,
        },
        isChild: {
            type: Boolean,
            default: false,
        },
        hasNotifications: {
            type: Boolean,
            default: false,
        },
        isExecutingPromotionsWithPendingNotifications: {
            type: Boolean,
            default: false,
        },
        disabled: {
            required: false,
            type: Boolean,
            default: false,
        },
        disabledReason: {
            required: false,
            type: String,
            default: null,
        },
    },
    data() {
        return {
            allowApplyAllNotifications,
        };
    },
    computed: {
        isScenario() {
            return this.entity === 'scenarios';
        },
        isDisabled() {
            return (
                this.disabled ||
                this.applyingNotifications ||
                !this.hasNotifications ||
                !this.entityId ||
                this.isExecutingPromotionsWithPendingNotifications
            );
        },
    },
};
</script>
